import { render, staticRenderFns } from "./RestriccionesPagination.vue?vue&type=template&id=114e5c1d&"
import script from "./RestriccionesPagination.vue?vue&type=script&lang=js&"
export * from "./RestriccionesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports